/**
 * Ob ein Besucher eine Hinweisleiste schliessen darf.
 *
 * Fleet-Kanon „Beta-Hinweis ist immer sichtbar“ (17.10.2026): Ein Banner der
 * Art `beta` hat KEINEN Schliessen-Knopf, und ein früher gemerktes Schliessen
 * (localStorage `paperball-dismissed-banners`) versteckt ihn nicht mehr. Bis
 * dahin war er per „X“ wegklickbar — einmal geklickt, für immer weg, und auf
 * der Startseite fehlte er „schon wieder“. Ausblenden darf ihn nur die
 * Verwaltung (aktiv/inaktiv, Zeitfenster), etwa wenn die Beta endet.
 *
 * Das steht hier im Code, nicht nur als Datenwert: Backend
 * (`routers/banners.py`, `NIE_WEGKLICKBAR`) und Datenbank
 * (`ck_system_banners_beta_nie_wegklickbar`) halten `is_dismissible` für
 * `beta` auf `false` — die Oberfläche verlässt sich trotzdem nicht darauf.
 *
 * Am Telefon löst die Leiste ihr Platzproblem durch Kompaktheit (eine Zeile,
 * „Mehr“ klappt auf), nicht durch Wegklicken.
 */
export const NIE_WEGKLICKBAR: ReadonlySet<string> = new Set(['beta']);

export interface BannerArt {
  style: string;
  is_dismissible: boolean;
}

export function istWegklickbar(banner: BannerArt): boolean {
  return banner.is_dismissible && !NIE_WEGKLICKBAR.has(banner.style);
}
